/** @internal */
export enum TokenSwapInstruction {
  Initialize = 0,
  Swap = 1,
  DepositAllTokenTypes = 2,
  WithdrawAllTokenTypes = 3,
  Claim = 4,
  ManagerClaim = 5,
  AddUserPosition = 6,
  UpdateFee = 7,
  SimulateSwap = 8,
  DepositFixToken = 9,
}
